import React, { Component } from 'react';
import * as ReactDOM from 'react-dom';
import {inject, observer} from 'mobx-react';
import {TextButton, TextButtonTypes} from '../Buttons';
import styles from './style.css';

@inject('localizationStore')
@observer
class ConfirmationModal extends Component {
    onWindowClick = (event) => {
        event.stopPropagation()
    }
    render() {
        const locale = this.props.localizationStore.locale
        return ReactDOM.createPortal((
            <div className={styles.modalContainer} onClick={this.props.onCancel} >

                <div className={styles.window} onClick={this.onWindowClick}>
                    <div className={styles.content}>
                        <div className={styles.question}>
                            {this.props.question !== undefined ?
                                this.props.question : locale.confirm_action
                            }
                        </div>
                        <div className={styles.buttons}>
                            <TextButton text={locale.cancel} onClick={this.props.onCancel}/>
                            <TextButton text={locale.apply} type={TextButtonTypes.primary} onClick={this.props.onApply}/>
                        </div>
                    </div>
                </div>
            </div>
            ),
            document.getElementById('dialogModal')
        );
    }
}

export default ConfirmationModal;


// WEBPACK FOOTER //
// ./src/components/ConfirmationModal/index.js